// Função para formatar data do formato americano (yyyy-mm-dd) para brasileiro (dd/mm/yyyy)
export const formatarDataEuaBrasil = (dataAmericana: string): string => {
  if (!dataAmericana) return "Não informado";

  try {
    // Se a data já está no formato correto ou tem barras, retorna como está
    if (dataAmericana.includes("/")) {
      return dataAmericana;
    }

    // Converte de yyyy-mm-dd para dd/mm/yyyy
    const [ano, mes, dia] = dataAmericana.split("-");
    return `${dia}/${mes}/${ano}`;
  } catch (error) {
    console.error("Erro ao formatar data:", error);
    return dataAmericana; // Retorna a data original se houver erro
  }
};
